import request from "@/utils/newResquest";

// 判断用户是否有区县服务商角色
export function getHaveDcspRole(params) {
  return request({
    url: "/toc/invoice/isHaveDcspRole",
    method: "get",
    params: params
  });
}

// 获取用户可开票的区县列表
export function getInvoiceDcspList(params) {
  return request({
    url: "/toc/invoice/getDcspDistrictList",
    method: "get",
    params: params
  });
}

// 保存发票信息
export function saveInvoiceInfo(data) {
  return request({
    url: "/toc/invoice/invoiceInfoSave",
    method: "post",
    data: data
  });
}

// 修改发票信息
export function updateInvoiceInfo(data) {
  return request({
    url: "/toc/invoice/invoiceInfoUpdate",
    method: "post",
    data: data
  });
}

// 删除发票信息
export function deleteInvoiceInfo(params) {
  return request({
    url: "/toc/invoice/invoiceDelete",
    method: "get",
    params: params
  });
}

// 获取公司信息记录
export function getCompanyInfoRecord(params) {
  return request({
    url: "/toc/invoice/getInvoiceInfoList",
    method: "get",
    params: params
  });
}

// 获取公司信息详情
export function getCompanyInfoDetail(params) {
  return request({
    url: "/toc/invoice/getInvoiceInfoDetail",
    method: "get",
    params: params
  });
}

// 提现详情页获取发票详情
export function getInvoiceInfoDetail(params) {
  return request({
    url: "/toc/withdrawal/invoiceDetail",
    method: "post",
    params: params
  });
}

// 钱包绑定 - 通过walletUserCode绑定钱包用户
export function ApiBindWallet(params) {
  return request({
    url: "/member/bindWallet",
    method: "get",
    params: params
  });
}

// 获取力宝会员标识
export function ApiGetMemberIdentity() {
  return request({
    url: "/member/liBao/getMemberIdentity",
    method: "get"
  });
}

// 获取权益账户信息
export function ApiGetRightsAccountInfo() {
  return request({
    url: "/toc/rights/getRightsAccount",
    method: "get"
  });
}

// 是否显示抢红包入口 当前会员剩余可用金豆大于0.002时显示
export function ApiIsShowRedPacket() {
  return request({
    url: "/toc/redPacket/showRedPacket",
    method: "get"
  });
}

// 查询今日红包领取消费券额和历史累计领取消费券额
export function ApiQueryHistoryClaimRedPacket() {
  return request({
    url: "/toc/redPacket/queryHistoryClaimRedPacket",
    method: "get"
  });
}

// 领取红包
export function ApiClaimRedPacket() {
  return request({
    url: "/toc/redPacket/claimRedPacket",
    method: "get"
  });
}

// 是否显示抢红包入口 当前会员剩余可用金豆大于0.002时显示
export function ApiCheckIsShowRedPacket() {
  return request({
    url: "/toc/redPacket/showRedPacket",
    method: "get"
  });
}

// 获取地址列表
export function ApiMemberAddresList(data) {
  return request({
    url: "/toc/memberAddress/list",
    method: "post",
    data: data
  });
}
export function ApiGetListStreet(params) {
  return request({
    url: "/toc/street/getList",
    method: "get",
    params: params
  });
}
export function ApiMemberAddressSaveOrUp(data) {
  return request({
    url: "/toc/memberAddress/saveOrUp",
    method: "post",
    data: data
  });
}
//删除地址
export function ApiMemberAddressDelete(params) {
  return request({
    url: "/toc/memberAddress/delete",
    method: "get",
    params: params
  });
}

//设置默认地址
export function ApiserDefaultAddress(params) {
  return request({
    url: "/toc/memberAddress/serDefaultAddress",
    method: "get",
    params: params
  });
}
export function ApiMessageQueryPage(data) {
  return request({
    url: "/toc/message/queryPage",
    method: "post",
    data: data
  });
}
//全部已读
export function ApiMessageReadAll() {
  return request({
    url: "/toc/message/readAll",
    method: "post"
  });
}

//全部删除
export function ApiMessageClearAll() {
  return request({
    url: "/toc/message/clearAll",
    method: "post"
  });
}
export function ApiMessageDelete(params) {
  return request({
    url: "/toc/message/delete",
    method: "get",
    params: params
  });
}
export function ApiMessageRead(params) {
  return request({
    url: "/toc/message/read",
    method: "get",
    params: params
  });
}
export function ApiGetFansList(data) {
  return request({
    url: "/member/getFansList",
    method: "post",
    data: data
  });
}
export function ApiMemberDefaultAddress() {
  return request({
    url: "/toc/memberAddress/defaultAddress",
    method: "get"
  });
}